// extracted by mini-css-extract-plugin
export default {"onboarding":"onboarding--SRkI0"};
    if(module.hot) {
      // 1747648130950
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  